import { makeStyles } from '@material-ui/core/styles';
import { wppColors } from '../../../App.styles';

export const useStyles = makeStyles((theme) => ({
  // A two-option segmented control rather than a dropdown: with exactly two
  // languages both are visible at a glance and switching is a single tap.
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px',
    borderRadius: '999px',
    backgroundColor: '#E9EBEF',
    border: '1px solid transparent',
    flexShrink: 0,
  },

  option: {
    appearance: 'none',
    border: 0,
    outline: 'none',
    cursor: 'pointer',
    padding: '5px 12px',
    borderRadius: '999px',
    backgroundColor: 'transparent',
    color: '#525252',
    fontFamily: 'inherit',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    lineHeight: 1,
    transition: 'background-color 120ms ease, color 120ms ease',

    '&:hover:not(:disabled)': {
      color: wppColors.navy,
    },

    '&:focus-visible': {
      boxShadow: `0 0 0 2px ${wppColors.orange700}`,
    },

    '&:disabled': {
      cursor: 'default',
    },
  },

  optionActive: {
    backgroundColor: wppColors.white,
    color: wppColors.navy,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.12)',
  },

  // A screen that forces its own language (Asset Control): the control stays
  // visible so the current language is still readable, but reads as inert.
  locked: {
    opacity: 0.6,
    cursor: 'not-allowed',
    '& $option:disabled': {
      cursor: 'not-allowed',
    },
  },

  // Header variant: sits between the profile button and Log out, and hides
  // its long form on narrow screens where space is tight.
  compact: {
    [theme.breakpoints.down('medium')]: {
      display: 'none',
    },
  },

  // Settings variant: labelled block used inside the profile page.
  block: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'flex-start',
  },

  blockLabel: {
    margin: 0,
    fontSize: '13px',
    fontWeight: 700,
    color: wppColors.black,
  },

  blockHint: {
    margin: 0,
    fontSize: '12.5px',
    lineHeight: 1.45,
    color: '#6B6B6B',
    maxWidth: '46ch',
  },

  error: {
    margin: 0,
    fontSize: '12.5px',
    lineHeight: 1.45,
    color: '#B3261E',
  },
}));
